<template>
  <div class="content">
    <Hero
      :image="getStrapiImageLocation(data?.heroImage) || ''"
      image-provider="strapi"
      extra-content-classes="grid--two"
    >
      <template #left>
        <div class="hero__heading">
          <div class="hero__heading-inner">
            <h1 class="heading-1 text--white text--bold">{{ data?.title }}</h1>
          </div>
        </div>
        <h4 class="heading-4 text--xxl text--white mb-1">{{ data?.leftHeading }}</h4>
        <ul class="list list--none mb-1">
          <li class="list__item text--white text--l">{{ data?.addressRow1 }}</li>
          <li class="list__item text--white text--l">{{ data?.addressRow2 }}</li>
          <li class="list__item text--white text--l">{{ data?.addressRow3 }}</li>
        </ul>
        <ul class="list list--none">
          <li class="list__item text--white text--l text--bold">
            <a :href="`tel:${data?.phoneValue}`" class="text--white">{{ data?.phoneDisplay }}</a>
          </li>
          <li class="list__item text--white text--l text--bold">
            <a href="mailto:info@vaneerd.nl" class="text--white">{{ data?.contactEmail }}</a>
          </li>
        </ul>
      </template>
      <template #right>
        <div>
          <ul 
            class="list list--none"
            v-for="(address, i) in data?.addressesRight"
            :key="address.id"
            :class="i < (data?.addressesRight?.length || 0) - 1 ? 'mb-1' : ''"
          >
            <li><h5 class="text--l text--white text--bold">{{ address.name }}</h5></li>
            <li><span class="text--white text--l">{{ address.addressRow1 }}</span></li>
            <li><span class="text--white text--l">{{ address.addressRow2 }}</span></li>
          </ul>
        </div>
      </template>
    </Hero>
    <div class="block block--yl">
      <FormContact 
        :data="data?.form"
        :page-id="data?.id"
        identifier="contact-page"
        name="Open sollicitatie (via contact pagina)"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type ContactPage from '~/typings/strapi/pages/contactPage';

const { findOne } = useStrapi();

const { data ,error } = await useAsyncData(
  'contactPage',
  async () => {
    const params = await useDraft({
      populate: [
        'addressesRight', 'form', 'heroImage', 'seo', 'seo.metaImage'
      ]
    });

    return await findOne<ContactPage>('contact-page', params);
  },
  {
    transform: flattenObject
  }
);

useCheckContentError(error, data);

useHead({
  titleTemplate: '%s | Van Eerd - Werken bij',
  title: 'Contact',
});

useSeoMeta({
  description: data.value?.seo?.metaDescription,
  ogTitle: data.value?.seo?.metaTitle,
  ogDescription: data.value?.seo?.metaDescription,
  ogImage: getStrapiImageLocation(data.value?.seo?.metaImage, true),
  ogUrl: 'https://werkenbijvaneerd.nl/contact',
  twitterTitle: data.value?.seo?.metaTitle,
  twitterDescription: data.value?.seo?.metaDescription,
  twitterImage: getStrapiImageLocation(data.value?.seo?.metaImage, true),
  twitterCard: 'summary_large_image',
})
</script>
